import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const freeTrialSubmitRegistrationCacheKeys: AllRouteEndpoints[] = ["/free_trial/submit_registration"];
